import { SyncEventType } from '../../enums/syncEventType';
import { Project } from '../../project';
import { PersistenceEvent } from './persistenceEvent';

/** notification about changed project data */
export class EventProjectUpdated implements PersistenceEvent {

  public readonly type = SyncEventType.PROJECT_UPDATED;
  public project: Project;

  constructor(changedProject: Project) {
    this.project = changedProject;
  }

  getPayload(): object {
    const payload = {
      'project': this.project
    };
    return payload;
  }

  static fromPayload(payload: any): EventProjectUpdated {
    return new EventProjectUpdated(
      payload['project']
    );
  }

}

